<template>
  <div>
      <full-page  ref="fullpageCharacters" :options="options" id="fullpageCharacters">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>


<div id="section05" class="section animated charBG-Pavement">

        <div id="charBG-ShadowMoon"></div>  
        <div id="charBG-MrWedensday"></div>  
        <div id="charBG-LauraMoon"></div>  
        <div id="charBG-MadSweeney"></div>  
        <div id="charBG-MrIbis"></div>  
        <div id="charBG-Salim"></div>  
        <div id="charBG-TheJinn"></div>  
        <div id="charBG-MrNancy"></div>  
        <div id="charBG-Bilquis"></div>  
        <div id="charBG-TechBoy"></div>  
        <div id="charBG-MrWorld"></div>  

     

        <b-container>
          <!-- <b-row>
            <b-col></b-col>
          </b-row> -->
          <b-row>
            <b-col>

            <div class="charTitle">
              <h2>CHARACTER BIOS</h2>
            </div>                            

              <div  id="charCircle" class="charCircle"></div>

              <a href="#page7"><div id="iconShadowMoon" class="charIcon iconShadowMoon"></div></a>
              <a href="#page47"><div id="iconMrWorld" class="charIcon iconMrWorld"></div></a>
              <a href="#page11"><div id="iconMrWedensday" class="charIcon iconMrWedensday"></div></a>
               <a href="#page43"><div  id="iconTechBoy" class="charIcon iconTechBoy"></div></a>
               <a href="#page15"><div  id="iconLauraMoon" class="charIcon iconLauraMoon"></div></a>
               <a href="#page39"><div  id="iconBilquis" class="charIcon iconBilquis"></div></a>
               <a href="#page19"><div  id="iconMadSweeney" class="charIcon iconMadSweeney"></div></a>
               <a href="#page35"><div  id="iconMrNancy" class="charIcon iconMrNancy"></div></a>
               <a href="#page23"><div  id="iconMrIbis" class="charIcon iconMrIbis"></div></a>
               <a href="#page31"><div  id="iconTheJinn" class="charIcon iconTheJinn"></div></a>
               <a href="#page27"><div  id="iconSalim" class="charIcon iconSalim"></div></a>


            </b-col>
          </b-row>
        </b-container>
        
        <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>



        <div id="section06" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterShadowMoon">

            <div id="posterShadowMoonBG" class="posterBG "></div>
            <div id="posterShadowMoon" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                    <p>WHAT HAPPENS IF I DON’T BELIEVE?</p>
                    </div>
                    <h1>SHADOW MOON</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>

          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section07" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterShadowMoon">
              <div id="charInformation-ShadowMoon" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                    <h1 data-heading="L">BELIEVE<br><span class="h1Small" data-heading="TI">- IN DESTINY -</span></h1>
                    <b-img src="../../static/svg/iconShadowMoon.svg" class="believeIcon" />
                    <h3>SHADOW MOON</h3>
                    <p>Shadow Moon is released from prison to a life turned upside down in Season one. He is offered a job by Mr. Wednesday as a bodyguard, and as they journey across America, Shadow finds himself questioning a world where gods exist, and magic is real. In Season two, he begins to understand this strange world of the gods and carve out a place in it as a believer, but it is far from a straight path.</p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section08" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterShadowMoon">
              <div id="charPortrait-ShadowMoon" class="characterPortraitBG"></div>

                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                              <p>played by:</p>
                              <h2>Ricky Whittle</h2>
                              <b-btn href="#page9/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                        <h2>Ricky Whittle</h2>
                                        <p>(Shadow Moon)</p>
                                        <b-btn href="#page9" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                  <p>Ricky Whittle previously starred as Lincoln, one of the Grounders, on The CW’s critically acclaimed drama “The 100. ”</p>
                                  <p>A native of Oldham, Greater Manchester, England, Whittle is best known for his role as Calvin Valentine in the popular series “Hollyoaks.” Other television credits include roles on “Mistresses,” “Single Ladies,” “NCIS,” and BBC One’s “Holby City.”</p>
                                  <p>On the big screen, Whittle appeared in the feature film Austenland, opposite Keri Russell, from Producers Stephanie Meyer and Jerusha Hess.</p>
                                  <p>In 2008, Whittle appeared on a celebrity edition of “The Weakest Link,” reaching the final round. In 2009, he was as a contestant on the BBC One reality television series “Strictly Come Dancing,” paired with Australian Professional Dancer Natalie Lowe. Whittle made it through to the finals of the competition, and competed against Television Presenter Chris Hollins.</p>
                                  <p>Whittle is the son of former Royal Air Force Serviceman Harry Whittle and grew up travelling around the world, with a home base near Reading, Berkshire. A keen sportsman, Whittle represented England and the United Kingdom at youth level in football and rugby. While at university, he began modeling and eventually became the face of a Reebok campaign in 2000. This brought him to the attention of casting agents for Sky One’s football soap opera “Dream Team.”</p>
                                  <p>He currently resides in Los Angeles.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section09" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterShadowMoon">
            <div class="slide slide0" id="ShadowMoon-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="ShadowMoon-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="ShadowMoon-Slide2" data-anchor="slide2"></div>
            <div class="slide slide3" id="ShadowMoon-Slide3" data-anchor="slide3"></div>
            <div class="slide slide4" id="ShadowMoon-Slide4" data-anchor="slide4"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>



        <div id="section10" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrWednesday">

              <div id="posterMrWednesdayBG" class="posterBG "></div>
            <div id="posterMrWednesday" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                    <p>great battles require great preparation.</p>
                    </div>
                    <h1>MR. WEDNESDAY</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section11" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrWednesday">
              <div id="charInformation-MrWednesday" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="E">BELIEVE<br><span class="h1Small" data-heading="I">— IN ME -</span></h1>
                <b-img src="../../static/svg/iconMrWedensday.svg" class="believeIcon" />
                <h3>MR. WEDNESDAY</h3>
                <p>Mr. Wednesday, a crafty and endlessly charismatic con man, is full of perverse wisdom, curious magic, and grand plans to unite the Old Gods in a battle for power against the New Gods. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section12" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrWednesday">
              <div id="charPortrait-MrWednesday" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                                <p>played by:</p>
                                <h2>Ian McShane</h2>
                              <b-btn href="#page13/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>Ian McShane</h2>
                                    <p>(Mr. Wednesday)</p>
                                        <b-btn href="#page13" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>From a lawless saloon owner to the most feared pirate that ever sailed the seas, Ian McShane certainly has carved out quite the niche playing bad guys one would cross the street to avoid. That just might have changed in recent roles in which he starred as Amphiarus (part priest, part prophet, part warrior) opposite Dwayne Johnson in Hercules for Director Brett Ratner; a salsa dance instructor opposite Nick Frost in Cuban Fury for Director James Griffiths; the good king of the land in Jack the Giant Slayer for director Bryan Singer; and in Snow White and the Huntsman as the lead dwarf Beith opposite Kristen Stewart and Chris Hemsworth.</p>
                                <p>McShane just reprised his role as Winston (club owner/conceivable ex-assassin) opposite Keanu Reeves in John Wick: Chapter Two for Director Chad Stahelski and Lionsgate. He appeared in cameo roles in Sacha Baron Cohen’s new comedy Grimsby directed by Louis Leterrier for Sony, and in the highly touted Spanish Director Daniel Monzón’s film El Niño.</p>
                                <p>Next starring in Bolden! McShane playscorrupt Judge Perry for Writer/Director Dan Pritzker in the story about the life of jazz innovator Buddy Bolden; and as Leland, a retired sheriff with violent tendencies opposite Patrick Wilson in The Hollow Point for Director Gonzalo López-Gallego, Atlas Independent, and Relativity.</p>
                                <p>McShane starred in the worldwide billion-dollar blockbuster Pirates of the Caribbean: On Stranger Tides as the fearsome pirate Blackbeard. He also starred as the conniving and manipulative, Waleran Bigod in the Emmy®-nominated “The Pillars of the Earth” for which he received a Golden Globe® Nomination for Best Actor in a Mini Series.</p>
                                <p>Highlights of his previous years in film include starring in and co-producing the motion picture 44 Inch Chest, lending his unique voice to the highly acclaimed animated features Coraline, Shrek the Third, Kung Fu Panda, and The Golden Compass.</p>
                                <p>His voice can next be heard as Umayya in the independent animated feature Bilal. He was also seen in Woody Allen’s Scoop. In the critically acclaimed indie Sexy Beast, McShane gave another riveting performance by transforming himself into the dark, sinister, and very handsome character Teddy Bass, prompting one London writer to declare McShane, “the king of cool.” Earlier in his career he starred in favorites The Last of Sheila, Pussycat, Pussycat, I Love You, and If It’s Tuesday, This Must Be Belgium.</p>
                                <p>McShane has also enjoyed a long and creatively diverse career in both British and American television. He recently played Andrew Finney opposite Liev Schreiber on the critically acclaimed Showtime series “Ray Donovan.” McShane also recently appeared in the award-winning series “Game of Thrones” on HBO. One of his most significant roles includes Al Swearengen on HBO’s “Deadwood.” McShane earned the coveted Golden Globe Award for ‘Best Actor in a Television Drama.’ His charismatic and alluring performance also led him to 2005 Emmy® and SAG nominations for ‘Lead Actor’, as well as being voted by People Magazine in 2005 as ‘TV's Sexiest Villain.’ Following a wave of critical acclaim for “Deadwood,” he received the Television Critics Association’s Award for ‘Individual Achievement in Drama’ and was named as one of GQ’s ‘Men of the Year,’ describing his character as “infectious” and “darkly irresistible.”</p>
                                <p>In the beginning of his career, McShane starred in “Roots,” followed by starring as Judas in NBC’s “Jesus of Nazareth” directed by Franco Zeffirelli. He played the title role in Masterpiece Theatre’s “Disraeli,” starred in the miniseries “A.D., Whose Life Is It Anyway?,” played Heathcliff in “Wuthering Heights,” and starred in Harold Pinter’s Emmy®-Award winning “The Caretaker.” McShane also starred in NBC’s critically lauded drama, “Kings.” In the late 80’s he formed McShane Productions, which produced the much-adored “Lovejoy” for the BBC and A&amp;E. “Lovejoy” gave McShane a vehicle to star in as well as produce and direct.</p>
                                <p>In addition to his screen work, McShane is a celebrated stage actor. In 2000 McShane returned to the West End in London to make his musical debut starring in The Witches of Eastwick as Darryl Van Horne. His varied stage career has included roles in Loot, The Admirable Crichton, The Glass Menagerie, and The Big Knife. He co-starred with Dame Judi Dench and Ian McKellen in The Promise, which successfully played London and was his Broadway debut. In Los Angeles, he starred in three productions at The Matrix Theatre, including the world premiere of Larry Atlas’ Yield of the Long Bond for which he received the Los Angeles Drama Critics’ Circle Award and Inadmissible Evidence and Betrayal. In 2008 McShane returned to Broadway to star in a revival of Harold Pinter’s The Homecoming for the 40th Anniversary of the play.</p>
                                <p>Born in Blackburn, England, Ian is the son of professional soccer player Harry McShane, who played for Manchester United, and Irene McShane. He attended the Royal Academy of Dramatic Art.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section13" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrWednesday">
            <div class="slide slide0" id="MrWednesday-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="MrWednesday-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="MrWednesday-Slide2" data-anchor="slide2"></div>
            <div class="slide slide3" id="MrWednesday-Slide3" data-anchor="slide3"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>
        


        <div id="section14" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterLauraMoon">

            <div id="posterLauraMoonBG" class="posterBG "></div>
            <div id="posterLauraMoon" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>i’m done with being dead.</p>
                  </div>
                  <h1>LAURA MOON</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section15" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterLauraMoon">
              <div id="charInformation-LauraMoon" class="characterInformationBG"></div>


              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="B">BELIEVE<br><span class="h1Small" data-heading="F">- IN LIFE -</span></h1>
                <b-img src="../../static/svg/iconLauraMoon.svg" class="believeIcon" />
                <h3>LAURA MOON</h3>
                <p> Laura Moon is Shadow Moon’s now “dead wife.” Little did she know that she would embark upon an unexpected journey leading her to an epiphany about her relationship and a second chance to make things right. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section16" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterLauraMoon">
              <div id="charPortrait-LauraMoon" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>EMILY BROWNING</h2>
                              <b-btn href="#page17/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>EMILY BROWNING</h2>
                                    <p>(Laura Moon)</p>
                                        <b-btn href="#page17" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>In a short time, Australian Actress Emily Browning has established herself as one of the industry’s most versatile and exciting young talents, balancing studio films with artful independent fare.</p>

                                <p>Browning first received international recognition when she was cast as Violet Baudelaire in the 2004 film adaptation of the popular children’s book series, Lemony Snicket’s A Series of Unfortunate Events. She received a 2005 Critics Choice Award nomination for ‘Best Young Actress’ from the Broadcast Film Critics Association on behalf of her performance, as well as a 2005 ‘Best Actress’ Award by the Australian Film Institute.</p>

                                <p>In 2011, Browning starred in Julia Leigh’s art-house film Sleeping Beauty, which had its world premiere at the Cannes Film Festival. While the film received mixed reactions from critics and journalists for pushing the envelope, Browning received critical praise for her demanding performance. She was honored with the ‘Breakthrough Performer’ Award at the 2011 Hamptons International Film Festival and received a ‘Best Actress in a Leading Role’ nomination by the Film Critics Circle of Australia, as well as the Australian Film Critics Association.</p>

                                <p>In 2014, Browning starred and sang in the musical feature film God Help the Girl, written and directed by Stuart Murdoch of the music group Belle and Sebastian. The film follows Eve (Browning), who escapes from a psychiatric hospital and makes her way to Glasgow, hoping to become a musician. God Help the Girl premiered in-competition in the World Cinema Dramatic Competition at the 2014 Sundance Film Festival, where it won the ‘Special Jury Prize’. That next month, the film served as the opening night film of the Generation’s SELECTION?? at the 64th Berlin International Film Festival.</p>

                                <p>Browning most recently appeared opposite Tom Hardy in the criminal biopic Legend, which was written and directed by Brian Helgeland. Legend depicts the rise and fall of real-life twin brothers, Reggie and Ronnie Kray, who dominated organized crime in London during the 1960s before their 1969 convictions for murder. Hardy portrays both Kray brothers and Browning plays Frances Shea, a woman who tragically falls for Reggie Kray and marries him. In October 2015, Universal Studios released the film in the U.S. after its premiere at Toronto International Film Festival in September 2015.</p>

                                <p>Browning recently completed production on Eddie O’Keefe’s directorial debut, Shangri-La Suite. The film, which was also written by O’Keefe and Chris Hutton, follows two young lovers, played by Browning and Luke Grimes, who break out of a mental hospital in 1974 and set out on a road trip to Los Angeles to fulfill the boy’s lifelong dream of killing his idol, Elvis Presley. Shangri-La Suite is being produced by Ron Yerxa and Albert Berger of Bona Fide Productions.</p>

                                <p>Browning’s debut acting role was in the 1998 Hallmark Channel movie The Echo of Thunder. Additional roles in her home country of Australia soon followed, including recurring roles in the television series’ “Blue Heelers,” “Something in the Air,” and “High Flyers.” Other film credits include: Ghost Shipi>, Ned Kelly, The Uninvited, Stranded, Sucker Punch, Magic Magic, The Host, Summer in February, Plush, and Pompeii.</p>

                                <p>Browning currently resides in Los Angeles.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section17" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterLauraMoon">
            <div class="slide slide0" id="LauraMoon-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="LauraMoon-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="LauraMoon-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>



        <div id="section18" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMadSweeney">

              <div id="posterMadSweeneyBG" class="posterBG "></div>
            <div id="posterMadSweeney" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>you promised me a battle. that’s the only reason I’m still here.</p>
                  </div>
                  <h1>MAD SWEENEY</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section19" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMadSweeney">
                            <div id="charInformation-MadSweeney" class="characterInformationBG"></div>


              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="L">BELIEVE<br><span class="h1Small" data-heading="UC">- IN LUCK -</span></h1>
                <b-img src="../../static/svg/iconMadSweeney.svg" class="believeIcon" />
                <h3>MAD SWEENEY</h3>
                <p>Mad Sweeney, the down on his luck leprechaun, is always up for a good fight. In the employment of Mr. Wednesday, Sweeney is never deprived but now finds himself as 
Laura Moon’s de facto keeper and still awaiting his battle.  </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section20" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMadSweeney">
              <div id="charPortrait-MadSweeney" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>PABLO SCHREIBER</h2>
                              <b-btn href="#page21/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>PABLO SCHREIBER</h2>
                                    <p>(Mad Sweeney)</p>
                                        <b-btn href="#page21" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Pablo Schreiber was recently nominated for an Emmy® Award for his performance as sadistic Corrections Officer George ‘Pornstache’ Mendez in the smash hit Netflix original series “Orange Is The New Black.” Schreiber was also recently seen starring opposite Tim Robbins and Jack Black in the HBO comedy series “The Brink” directed by Jay Roach, and in a major recurring role on “Law and Order: SVU” as sociopathic serial killer William Lewis who kidnaps and torments Olivia Benson played by Mariska Hargitay.</p>

                                <p>He was recently seen starring in the Paramount film 13 Hours: The Secret Soldiers of Benghazi directed by Michael Bay. Next up, he will be seen in several films including The King’s Daughter opposite Pierce Brosnan and William Hurt; the Cary Fukanagaproduced film Thumper opposite Eliza Taylor and Lena Headey; the lead of the independent drama Traces; and the comedy film Big Bear opposite Adam Brody and Zachary Knighton.</p>

                                <p>On stage, Schreiber was nominated for a Tony® Award for his Broadway debut performance in the revival of Clifford Odets’ classic Awake and Sing! directed by Bartlett Sher.</p>

                                <p>He has appeared in many films, including: Josh Radnor’s Happythankyoumoreplease, which won the ‘Audience Award’ at Sundance, Vicky Christina Barcelona, The Lords of Dogtown, Tell Tale, Nights in Rodanthe, The Manchurian Candidate, Allegiance, Breaking Upwards, Into the Fire, The Mudge Boy, and Invitation to a Suicide. He appears in Stephen Frears’ upcoming Muhammad Ali’s Greatest Fight and the independent features The Dramatics and Fort Bliss.</p>

                                <p>Other television credits include his classic role as Nick Sobotka in HBO’s critically acclaimed “The Wire” “Weeds,” “A Gifted Man,” “Light’s Out,” “The Good Wife,” “White Collar,” “The Beast,” “Life on Mars,” “It’s Always Sunny in Philadelphia,” “Fear Itself,” “Dirt,” “A Painted House,” “Law & Order,” “Law & Order: Criminal Intent,” and “The Black Donnellys.”</p>

                                <p>Schreiber has performed in numerous Broadway and off-Broadway plays including: Desire Under the Elms on Broadway directed by Robert Falls, Rajiv Joseph’s Gruesome Playground Injuries at Second Stage, Neil LaBute’s Reasons to be Pretty at MCC (for which he won the ‘Drama Desk Award’), Dying City at Lincoln Center, Mr. Marmalade at Roundabout, Sin: A Cardinal Deposed at The New Group, Manuscript at the Daryl Roth Theatre, Julius Caesar at the New York Shakespeare Festival, and Blood Orange which was his professional debut.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section21" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMadSweeney">
            <div class="slide slide0" id="MadSweeney-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="MadSweeney-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="MadSweeney-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>



        <div id="section22" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrIbis">

              <div id="posterMrIbisBG" class="posterBG "></div>
            <div id="posterMrIbis" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                                     <p>Sooner or later they all lie before me. War need not be the answer.</p>
                  </div>
                  <h1>MR. IBIS</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section23" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrIbis">
              <div id="charInformation-MrIbis" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="V">BELIEVE<br><span class="h1Small" data-heading="L">- IN TRUTH -</span></h1>
                <b-img src="../../static/svg/iconMrIbis.svg" class="believeIcon" />
                <h3>MR. IBIS</h3>
                <p>Mr. Ibis is the keeper of stories, past and present, and he recounts them with great relish. His old-fashioned sensibilities do not preclude a wry wit.</p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section24" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrIbis">
              <div id="charPortrait-MrIbis" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>DEMORE BARNES</h2>
                              <b-btn href="#page25/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>DEMORE BARNES</h2>
                                    <p>(Mr. Ibis)</p>
                                        <b-btn href="#page25" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Demore Barnes landed his first professional role right out of high school in his hometown of Toronto on “Squawk Box”, a sketch comedy show on YTV (Canada’s version of Nickelodeon) and has since been a rising star.</p>

                                <p>Barnes then went on to star in the CBC kids show “Street Cents.” He spent the next three seasons on the show doing sketch comedy.</p>

                               <p>Barnes then crossed-over into the dramatic realm of performance within the television movies, “White Lies,” with Sarah Polley and Lynn Redgrave, “Second String” with Jon Voight and “Black Out” with Jane Seymour. Shortly after, Barnes was cast as Benjamin Hardaway on the CTV legal drama, “The Associates,” and was thrust into the media maelstrom. For that role, Demore was nominated two consecutive years for the Gemini Award as Best Lead Actor in a Dramatic Series. In addition, Demore was the winner of the BFV and Black Film Award for Best Performance in a Dramatic Series for his work on The Associates.</p>

                                <p>Barnes then began working between both Los Angeles and Vancouver and was soon chosen by Academy Award nominee and preeminent playwright, David Mamet, to portray super-secret military commando, Hector Williams in his CBS and 20th Century Fox series, “The Unit.” The series was also nominated two consecutive years for an NAACP Award for Outstanding Drama Series. Barnes went on to land a recurring role in the CW Network hit, “Supernatural” as the Archangel Raphael and also guest starred on Fox’s “Fringe” as Agent Hubert and Universal’s “Caprica” as Nigel Hightower. Barnes has also guest starred in the CBC hit series, “Being Erica” as University of Toronto professor and author, Michel Streith opposite Erin Karpluck.</p>

                                <p>Other credits include an appearance in the Darren Lynn Bouseman directed horror film, The Barrens with Stephen Moyer and Mia Kirshner, as well as guest starring roles in the CTV and ION series, “Flashpoint,” HBO and Cinemax’s “Transporter,” and the NBC series “Hannibal”.</p>

                                <p>Barnes was chosen by Executive Producer and Academy Award winner Roger Avary to portray the recurring role of National Security Advisor to the President of the United States, Martin Reynolds in the Canal+ action series, “XIII.”</p>

                                <p>In the last two years, Demore has been juggling series regular and recurring roles on “Hemlock Grove” for Netflix, “Open Heart” for YTV and Nickelodeon as well as “12 Monkeys” for Syfy network. He had a two episode arc on “Defiance” for Syfy and a guest starring role on “The Flash” for the CW.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section25" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrIbis">
            <div class="slide slide0" id="MrIbis-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="MrIbis-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="MrIbis-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>




        <div id="section26" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterSalim">

              <div id="posterSalimBG" class="posterBG "></div>
            <div id="posterSalim" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>THE FIRST PILLAR OF ISLAM IS “THERE IS NO GOD BUT GOD.”</p>
                  </div>
                  <h1>SALIM</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section27" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterSalim">
              <div id="charInformation-Salim" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="V">BELIEVE<br><span class="h1Small" data-heading="L">- IN YOURSELF -</span></h1>
                <b-img src="../../static/svg/iconSalim.svg" class="believeIcon" />
                <h3>SALIM</h3>
                <p>Longing for inspiration and meaning in his life, an unexpected encounter with The Jinn while on a business trip in New York fulfilled that deepest wish and led him on an unexpected journey.</p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section28" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterSalim">
              <div id="charPortrait-Salim" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>OMID ATAHI</h2>
                              <b-btn href="#page29/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>OMID ATAHI</h2>
                                    <p>(Salim)</p>
                                        <b-btn href="#page29" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                  <p>Prior to his move to the United States, Omid Abtahi (Yusuf) spent his childhood living in Europe and the Middle East. Abtahi has a very personal connection to the film, <em>Brothers</em>, as he has a brother in the U.S. Military who served in the war in Afghanistan. He has seen firsthand the effect war can have not only on the individual but on the family as well.</p>
                                  <p>Abtahi is best known for his work as a series regular on FX&rsquo;s &ldquo;Over There&rdquo; and Showtime&rsquo;s &ldquo;Sleeper Cell&rdquo;. He has recurred heavily on NBC&rsquo;s &ldquo;My Own Worst Enemy&rdquo; and Fox&rsquo;s &ldquo;24&rdquo;. Abtahi appeared in <em>The Mysteries of Pittsburgh</em>, which premiered at Sundance in 2008, starring alongside Peter Sarsgaard, Nick Nolte, Jon Foster, and Sienna Miller.</p>
                                  <p>Prior to his television and film career, Abtahi performed on stage in many theatrical productions including <em>Fraulein Else</em> at the Berkeley Repertory, McCarter Theatre, and Longwarf Theatre; <em>Adoration of the Old Woman</em> at the Sundance Theatre Lab; and <em>Your Everyday Romantic Comedy</em> at the Kennedy Center.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section29" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterSalim">
            <div class="slide slide0" id="Salim-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="Salim-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="Salim-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>




        <div id="section30" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterTheJinn">

             <div id="posterTheJinnBG" class="posterBG "></div>
            <div id="posterTheJinn" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                   <p>it’s a god thing. you wouldn’t understand.</p>
                  </div>
                  <h1>THE JINN</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section31" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterTheJinn">
              <div id="charInformation-TheJinn" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="V">BELIEVE<br><span class="h1Small" data-heading="L">- IN WISHES -</span></h1>
                <b-img src="../../static/svg/iconTheJinn.svg" class="believeIcon" />
                <h3>THE JINN</h3>
                <p> The Jinn is a mythical creature of the fire who understands a person’s deepest desires better than they do. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section32" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterTheJinn">
              <div id="charPortrait-TheJinn" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>MOUSA KRAISH</h2>
                              <b-btn href="#page33/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>MOUSA KRAISH</h2>
                                    <p>(The Jinn)</p>
                                        <b-btn href="#page33" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Mousa Kraish is a Palestinian-American actor from Brooklyn, New York. In his career he has had the good fortune to work with a number of acclaimed directors including Steven Spielberg (Munich), Mike Nichols (Charlie Wilson's War), Justin Lin (Finishing the Game and Fast and Furious) and Greg Mottola, for whom Mousa appeared in the Judd Apatow-produced runaway summer hit Superbad. Television appearances include “Feed the Beast,” “Homeland,” “Transparent,” “Chuck,” “Covert Affairs,” “Blue Bloods,” “Parenthood,” “Arrested Development” and “Men of a Certain Age.” Other film credits include The Day the Earth Stood Still and You Don't Mess with the Zohan, as well as the independent features King of California, Super Zeroes, Overnight, and Echo Park.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section33" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterTheJinn">
            <div class="slide slide0" id="TheJinn-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="TheJinn-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="TheJinn-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>



        <div id="section34" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrNancy">

             <div id="posterMrNancyBG" class="posterBG "></div>
            <div id="posterMrNancy" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>I DON’T BUILD WEBS WHEN THE WINDS OF CHANGE ARE BLOWING LIKE A FUCKING HURRICANE.</p>
                  </div>
                  <h1>MR. NANCY</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section35" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrNancy">
              <div id="charInformation-MrNancy" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="E">BELIEVE<br><span class="h1Small" data-heading="I">- IN STORIES -</span></h1>
                <b-img src="../../static/svg/iconMrNancy.svg" class="believeIcon" />
                <h3>MR. NANCY</h3>
                <p> Part of Mr. Wednesday’s army, Mr. Nancy, or Anansi as he’s otherwise known, is the African trickster spider god with a taste for chaos. A god of knowledge and speech, he is happy to share his gifts with anyone who will listen. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section36" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrNancy">
              <div id="charPortrait-MrNancy" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>ORLANDO JONES</h2>
                              <b-btn href="#page37/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>ORLANDO JONES</h2>
                                    <p>(Mr. Nancy)</p>
                                        <b-btn href="#page37" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>In a career spanning 30 years, Orlando Jones’ versatility is well documented. He began his career by launching an advertising agency in his teens and then working behind the scenes as a writer on “A Different World” and “Martin.” He wrote and produced “Roc Live”, the first prime time scripted American series since the late 1950s to broadcast each episode of an entire season live. He then worked as part of the creative team that launched the FX Network into 18 million homes as a writer and on-camera personality. Jones later combined his writing and acting talents when he was handpicked by Quincy Jones to join sketch comedy franchise, “MadTV.” Following his tenure on the show he partnered with 7Up to write, produce and star in a series of iconic television commercials that are still recognized among the Top 100 most successful advertising campaigns of all time.</p>

                              <p>Heralded as a creative innovator across multiple media platforms, Jones was recognized as WhoSay’s Social Media Celebrity of 2014 and MTV’s “King of Fandom” in 2015. His passionate advocacy for the changing relationship between fans and creators has afforded him the opportunity to speak at various fan studies, conferences, and contribute to numerous academic publications.</p>

                              <p>In 2015, Jones co-founded the immersive content studio Legion of Creatives with former Disney executive Jay Williams and writer/producer Noam Dromi. The company is producing a wide range of multi-platform programs including the original series “High School 51”, created by Star Trek, Transformers, and Amazing Spiderman 2 writer/producer Roberto Orci.</p>

                              <p>In 2016, Jones was chosen by the Academy of Motion Picture Arts and Sciences to host The Oscars Backstage for the 88th Academy Awards, an interactive second screen experience tied to the official broadcast of the event.</p>

                              <p>Later this year, he'll be seen in the independent feature film The Devil and The Deep Blue Sea as well as the film Tainted Love, based on the graphic novel-style action comedy, which he also wrote and produced. It’s a first of its kind digital feature that is the launching pad for a unique narrative journey across multiple platforms.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section37" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrNancy">
            <div class="slide slide0" id="MrNancy-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="MrNancy-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="MrNancy-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>




        <div id="section38" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterBilquis">

            <div id="posterBilquisBG" class="posterBG "></div>
            <div id="posterBilquis" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>war and love may sit on opposite sides of a coin, but only so they may never have to face each other.</p>
                  </div>
                  <h1>BILQUIS</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section39" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterBilquis">
              <div id="charInformation-Bilquis" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="V">BELIEVE<br><span class="h1Small" data-heading="L">- IN LOVE -</span></h1>
                <b-img src="../../static/svg/iconBilquis.svg" class="believeIcon" />
                <h3>BILQUIS</h3>
                <p> Bilquis, an ancient goddess of love who craves the worship she inspired in eras long gone, is eager to find that same relevance in today’s world. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section40" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterBilquis">
              <div id="charPortrait-Bilquis" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>YETIDE BADAKI</h2>
                              <b-btn href="#page41/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>YETIDE BADAKI</h2>
                                    <p>(Bilquis)</p>
                                        <b-btn href="#page41" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Yetide Badaki has joined the cast of the STARZ Original Series “American Gods” in the role of Bilquis. The Nigerian born actress grew up in England and the United States, and has spent most of her career working in the theater. She recently guest starred on the Showtime series “Masters of Sex” and was on Sony Crackle series “Sequestered” with Jesse Bradford and Summer Glau. Additional credits include guest starring roles on the David Duchovny NBC series “Aquarius,” “US,” “NCIS: New Orleans,” and “Criminal Minds.”</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section41" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterBilquis">
            <div class="slide slide0" id="Bilquis-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="Bilquis-Slide1" data-anchor="slide1"> </div>
            <div class="slide slide2" id="Bilquis-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>





        <div id="section42" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterTechBoy">

           
            <div id="posterTechBoyBG" class="posterBG "></div>
            <div id="posterTechBoy" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>I am man’s greatest achievement... I’m fucking molecular. without me – shit don’t spin.</p>
                  </div>
                  <h1>TECHNICAL BOY</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section43" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterTechBoy">
              <div id="charInformation-TechBoy" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="V">BELIEVE<br><span class="h1Small" data-heading="L">- IN THE FUTURE -</span></h1>
                <b-img src="../../static/svg/iconTechBoy.svg" class="believeIcon" />
                <h3>TECHNICAL BOY</h3>
                <p>Technical Boy, a New God, is purveyor of all things technology and as such, struggles to remain on the cutting edge. He’s desperate to prove himself, and hungry for respect and power. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section44" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterTechBoy">
              <div id="charPortrait-TechBoy" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>BRUCE LANGLEY</h2>
                              <b-btn href="#page45/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>BRUCE LANGLEY</h2>
                                    <p>(Technical Boy)</p>
                                        <b-btn href="#page45" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Newcomer Bruce Langley is a young actor with an extensive background in physical, naturalistic, and improvised performance. He graduated with a First Class Masters in Physical Actor Training and Performance in 2014 from the University of Kent.</p>
                                <p>Langley’s recent credits include: Chase in Faith Drama’s production of The Den, Charlie in The Brockley Jack’s Rock Paper Scissors. “American Gods” is his first television role.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section45" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterTechBoy">
            <div class="slide slide0" id="TechBoy-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="TechBoy-Slide1" data-anchor="slide1"> </div>
             <div class="slide slide2" id="TechBoy-Slide2" data-anchor="slide2"></div>
          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>



        <div id="section46" class="section characterIntroduction">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrWorld">

            
            <div id="posterMrWorldBG" class="posterBG "></div>
            <div id="posterMrWorld" class="posterChar "></div>

            <div class="videoName">
              <b-container fluid class="h-100 ">
                <b-row class="h-100 align-items-end justify-content-center">
                  <b-col sm="12">
                    <div class="quoteWrap">
                  <p>we built the new world on top of the ruins of the old.</p>
                  </div>
                  <h1>MR. WORLD</h1>
                  </b-col>
                </b-row>
              </b-container>
            </div>

          </div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section47" class="section characterInformation">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrWorld">
              <div id="charInformation-MrWorld" class="characterInformationBG"></div>

              <b-container fluid class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
                  <b-col sm="8">
                <h1 data-heading="L">BELIEVE<br><span class="h1Small" data-heading="W">- IN FEAR -</span></h1>
                <b-img src="../../static/svg/iconMrWorld.svg" class="believeIcon" />
                <h3>MR. WORLD</h3>
                <p> Mr. World is the seemingly omniscient leader at the center of the New Gods coalition, sometimes more challenged by his own subordinates than his enemies. With an eye on the activities of the Old Gods, he is planning his revenge on Mr. Wednesday. </p>
                  </b-col>
                </b-row>
              </b-container>
            </div>

           <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section48" class="section characterPortrait">
             <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

            <div class="characterMrWorld">
              <div id="charPortrait-MrWorld" class="characterPortraitBG"></div>


                <div class="slide" id="slide1" data-anchor="slide1">
                  <b-container fluid class="h-100 ">
                  <b-row class="h-100 align-items-lg-center justify-content-lg-start align-items-md-end justify-content-md-center align-items-end justify-content-center">
                      <b-col sm="10">
                          <div class="actorInfoBtn">
                        <p>played by:</p>
                        <h2>CRISPIN GLOVER</h2>
                              <b-btn href="#page49/slide2" >Actor Bio</b-btn>
                          </div>
                      </b-col>
                      </b-row>
                  </b-container>
                  <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
                </div>


                <div class="slide characterPortraitBio" data-anchor="slide2">
                    <div class="bioWrap">
                        <b-container fluid class="h-100">
                            <b-row class="h-100 align-items-sm-start justify-content-center">
                                <b-col sm="3">
                                    <div class="actorInfoBtn">
                                    <h2>CRISPIN GLOVER</h2>
                                    <p>(Mr. World)</p>
                                        <b-btn href="#page49" >Actor Portrait</b-btn>
                                    </div>
                                </b-col>
                                <b-col sm="6">    
                                <p>Crispin Hellion Glover is a multifaceted American artist. He is primarily known as a film actor, but is also a publisher, filmmaker, and author. His career has been marked by some portrayals of wonderfully eccentric people, such as George McFly in Back to the Future and Willard Stiles in Willard. In the late 1980s, Glover started his own publishing company Volcanic Eruptions, which turned in to a production company in the 1990s for his film works.</p>

                                <p>Born in New York City, Glover moved to Los Angeles at the age of three and a half. As a child, he attended Mirman School for Highly Gifted Children. His father, Bruce Glover, is an actor best remembered for playing the offbeat Spectre assassin Mr. Wint in the James Bond movie Diamonds Are Forever and one of Jack Nicholson’s assistants, Duffy, in Chinatown. Crispin Glover’s first professional acting appearance was in 1978 in Los Angeles at the Dorothy Chandler Pavilion in The Sound of Music. He played Friedrich Von Trapp to Florence Henderson’s Maria. He also appeared in some commercials and several sitcoms as a teenager. His first film role was in 1983’s My Tutor, following with a small role in Racing with the Moon opposite Sean Penn. He also played the title role in an AFI film The Orkly Kid, in which he portrayed a young man whose obsession with Olivia Newton-John raises the ire of his small-town neighbors. Later that year he appeared in Friday the 13th: The Final Chapter (1984) and Teachers.</p>

                                <p>His breakout performance came in Robert Zemeckis’ Back to the Future, an international box office smash. Glover next starred in River’s Edge. From that point, Glover pursued a defiantly individualistic path. His characters were notable for their peculiar personality traits and unconventional thought processes. He played Andy Warhol in Oliver Stone’s The Doors in 1991 and continued to play exceedingly eccentric types, e.g. the title characters in Bartleby (2001) and Willard (2003). He played the Thin Man in the Charlie’s Angels, was seen in Hot Tub Time Machine, Tim Burton’s Alice in Wonderland, and has various upcoming feature film appearances.</p>

                                <p>Glover has been touring since 2005 with his two feature films What Is It? and its sequel It Is Fine! Everything Is Fine. He is using an unusual self-distribution model for his films that includes performing live shows titled Crispin Hellion Glover’s Big Slide Show Parts 1 & 2. These shows are each a one-hour dramatic narration of eight different profusely illustrated books. The images from these books are projected behind him. He continues to tour the world with these two films. They have each won awards at the Ann Arbor Film Festival and the Sitges International Film Festival. Crispin is editing his next feature film which is currently untitled and features himself and his father acting together for the first time.</p>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

            </div>
        </div>



        <div id="section49" class="section characterPhotos">
          <a href="#page6"><b-img src="../../static/img/charCircleDefault.png" class="charNav" /></a>

          <div class="characterMrWorld">
            <div class="slide slide0" id="MrWorld-Slide0" data-anchor="slide0"></div>
            <div class="slide slide1" id="MrWorld-Slide1" data-anchor="slide1"> </div>
             <div class="slide slide2" id="MrWorld-Slide2" data-anchor="slide2"></div>
          </div>
          <!-- <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" /> -->
        </div>

      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Characters',
  metaInfo: {
    title: 'Characters' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11', 'page12', 'page13', 'page14', 'page15', 'page16', 'page17', 'page18', 'page19', 'page20', 'page21', 'page22', 'page23', 'page24', 'page25', 'page26', 'page27', 'page28', 'page29', 'page30', 'page31', 'page32', 'page33', 'page34', 'page35', 'page36', 'page37', 'page38', 'page39', 'page40', 'page41', 'page42', 'page43', 'page44', 'page45', 'page46', 'page47', 'page48', 'page49', 'page50'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageCharacters.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      // Poster Animations
      var posterShadowMoonBG = document.querySelector('#posterShadowMoonBG')
      var posterShadowMoon = document.querySelector('#posterShadowMoon')
      if (destination.index === 2 || destination.index === 1 || destination.index === 3) {
        posterShadowMoonBG.classList.add('loadImage')
        posterShadowMoon.classList.add('loadImage')
      }
      if (destination.index === 2) {
        posterShadowMoonBG.classList.add('posterBGAni')
        posterShadowMoon.classList.add('posterCharAni')
      } else {
        posterShadowMoonBG.classList.remove('posterBGAni')
        posterShadowMoon.classList.remove('posterCharAni')
      }
      if (destination.index === 3 || destination.index === 2 || destination.index === 4) {
        document.getElementById('charInformation-ShadowMoon').classList.add('loadImage')
      }
      if (destination.index === 4 || destination.index === 3 || destination.index === 5) {
        document.getElementById('charPortrait-ShadowMoon').classList.add('loadImage')
      }
      if (destination.index === 5 || destination.index === 4 || destination.index === 6) {
        document.getElementById('ShadowMoon-Slide0').classList.add('loadImage')
        document.getElementById('ShadowMoon-Slide1').classList.add('loadImage')
        document.getElementById('ShadowMoon-Slide2').classList.add('loadImage')
        document.getElementById('ShadowMoon-Slide3').classList.add('loadImage')
        document.getElementById('ShadowMoon-Slide4').classList.add('loadImage')
      }
      var posterMrWednesdayBG = document.querySelector('#posterMrWednesdayBG')
      var posterMrWednesday = document.querySelector('#posterMrWednesday')
      if (destination.index === 2 || destination.index === 6 || destination.index === 5 || destination.index === 7) {
        posterMrWednesdayBG.classList.add('loadImage')
        posterMrWednesday.classList.add('loadImage')
      }
      if (destination.index === 6) {
        posterMrWednesdayBG.classList.add('posterBGAni')
        posterMrWednesday.classList.add('posterCharAni')
      } else {
        posterMrWednesdayBG.classList.remove('posterBGAni')
        posterMrWednesday.classList.remove('posterCharAni')
      }
      if (destination.index === 7 || destination.index === 6 || destination.index === 8) {
        document.getElementById('charInformation-MrWednesday').classList.add('loadImage')
      }
      if (destination.index === 8 || destination.index === 7 || destination.index === 9) {
        document.getElementById('charPortrait-MrWednesday').classList.add('loadImage')
      }
      if (destination.index === 9 || destination.index === 8 || destination.index === 10) {
        document.getElementById('MrWednesday-Slide0').classList.add('loadImage')
        document.getElementById('MrWednesday-Slide1').classList.add('loadImage')
        document.getElementById('MrWednesday-Slide2').classList.add('loadImage')
        document.getElementById('MrWednesday-Slide3').classList.add('loadImage')
      }
      var posterLauraMoonBG = document.querySelector('#posterLauraMoonBG')
      var posterLauraMoon = document.querySelector('#posterLauraMoon')
      if (destination.index === 2 || destination.index === 10 || destination.index === 9 || destination.index === 11) {
        posterLauraMoonBG.classList.add('loadImage')
        posterLauraMoon.classList.add('loadImage')
      }
      if (destination.index === 10) {
        posterLauraMoonBG.classList.add('posterBGAni')
        posterLauraMoon.classList.add('posterCharAni')
      } else {
        posterLauraMoonBG.classList.remove('posterBGAni')
        posterLauraMoon.classList.remove('posterCharAni')
      }
      if (destination.index === 11 || destination.index === 10 || destination.index === 12) {
        document.getElementById('charInformation-LauraMoon').classList.add('loadImage')
      }
      if (destination.index === 12 || destination.index === 11 || destination.index === 13) {
        document.getElementById('charPortrait-LauraMoon').classList.add('loadImage')
      }
      if (destination.index === 13 || destination.index === 12 || destination.index === 14) {
        document.getElementById('LauraMoon-Slide0').classList.add('loadImage')
        document.getElementById('LauraMoon-Slide1').classList.add('loadImage')
        document.getElementById('LauraMoon-Slide2').classList.add('loadImage')
      }
      var posterMadSweeneyBG = document.querySelector('#posterMadSweeneyBG')
      var posterMadSweeney = document.querySelector('#posterMadSweeney')
      if (destination.index === 2 || destination.index === 14 || destination.index === 13 || destination.index === 15) {
        posterMadSweeneyBG.classList.add('loadImage')
        posterMadSweeney.classList.add('loadImage')
      }
      if (destination.index === 14) {
        posterMadSweeneyBG.classList.add('posterBGAni')
        posterMadSweeney.classList.add('posterCharAni')
      } else {
        posterMadSweeneyBG.classList.remove('posterBGAni')
        posterMadSweeney.classList.remove('posterCharAni')
      }
      if (destination.index === 15 || destination.index === 14 || destination.index === 16) {
        document.getElementById('charInformation-MadSweeney').classList.add('loadImage')
      }
      if (destination.index === 16 || destination.index === 15 || destination.index === 17) {
        document.getElementById('charPortrait-MadSweeney').classList.add('loadImage')
      }
      if (destination.index === 17 || destination.index === 16 || destination.index === 18) {
        document.getElementById('MadSweeney-Slide0').classList.add('loadImage')
        document.getElementById('MadSweeney-Slide1').classList.add('loadImage')
        document.getElementById('MadSweeney-Slide2').classList.add('loadImage')
      }
      var posterMrIbisBG = document.querySelector('#posterMrIbisBG')
      var posterMrIbis = document.querySelector('#posterMrIbis')
      if (destination.index === 2 || destination.index === 18 || destination.index === 17 || destination.index === 19) {
        posterMrIbisBG.classList.add('loadImage')
        posterMrIbis.classList.add('loadImage')
      }
      if (destination.index === 18) {
        posterMrIbisBG.classList.add('posterBGAni')
        posterMrIbis.classList.add('posterCharAni')
      } else {
        posterMrIbisBG.classList.remove('posterBGAni')
        posterMrIbis.classList.remove('posterCharAni')
      }
      if (destination.index === 19 || destination.index === 18 || destination.index === 20) {
        document.getElementById('charInformation-MrIbis').classList.add('loadImage')
      }
      if (destination.index === 20 || destination.index === 19 || destination.index === 21) {
        document.getElementById('charPortrait-MrIbis').classList.add('loadImage')
      }
      if (destination.index === 21 || destination.index === 20 || destination.index === 22) {
        document.getElementById('MrIbis-Slide0').classList.add('loadImage')
        document.getElementById('MrIbis-Slide1').classList.add('loadImage')
        document.getElementById('MrIbis-Slide2').classList.add('loadImage')
      }
      var posterSalimBG = document.querySelector('#posterSalimBG')
      var posterSalim = document.querySelector('#posterSalim')
      if (destination.index === 2 || destination.index === 22 || destination.index === 21 || destination.index === 23) {
        posterSalimBG.classList.add('loadImage')
        posterSalim.classList.add('loadImage')
      }
      if (destination.index === 22) {
        posterSalimBG.classList.add('posterBGAni')
        posterSalim.classList.add('posterCharAni')
      } else {
        posterSalimBG.classList.remove('posterBGAni')
        posterSalim.classList.remove('posterCharAni')
      }
      if (destination.index === 23 || destination.index === 22 || destination.index === 24) {
        document.getElementById('charInformation-Salim').classList.add('loadImage')
      }
      if (destination.index === 24 || destination.index === 23 || destination.index === 25) {
        document.getElementById('charPortrait-Salim').classList.add('loadImage')
      }
      if (destination.index === 25 || destination.index === 24 || destination.index === 26) {
        document.getElementById('Salim-Slide0').classList.add('loadImage')
        document.getElementById('Salim-Slide1').classList.add('loadImage')
        document.getElementById('Salim-Slide2').classList.add('loadImage')
      }
      var posterTheJinnBG = document.querySelector('#posterTheJinnBG')
      var posterTheJinn = document.querySelector('#posterTheJinn')
      if (destination.index === 2 || destination.index === 26 || destination.index === 25 || destination.index === 27) {
        posterTheJinnBG.classList.add('loadImage')
        posterTheJinn.classList.add('loadImage')
      }
      if (destination.index === 26) {
        posterTheJinnBG.classList.add('posterBGAni')
        posterTheJinn.classList.add('posterCharAni')
      } else {
        posterTheJinnBG.classList.remove('posterBGAni')
        posterTheJinn.classList.remove('posterCharAni')
      }
      if (destination.index === 27 || destination.index === 26 || destination.index === 28) {
        document.getElementById('charInformation-TheJinn').classList.add('loadImage')
      }
      if (destination.index === 28 || destination.index === 27 || destination.index === 29) {
        document.getElementById('charPortrait-TheJinn').classList.add('loadImage')
      }
      if (destination.index === 29 || destination.index === 28 || destination.index === 30) {
        document.getElementById('TheJinn-Slide0').classList.add('loadImage')
        document.getElementById('TheJinn-Slide1').classList.add('loadImage')
        document.getElementById('TheJinn-Slide2').classList.add('loadImage')
      }
      var posterMrNancyBG = document.querySelector('#posterMrNancyBG')
      var posterMrNancy = document.querySelector('#posterMrNancy')
      if (destination.index === 2 || destination.index === 30 || destination.index === 29 || destination.index === 31) {
        posterMrNancyBG.classList.add('loadImage')
        posterMrNancy.classList.add('loadImage')
      }
      if (destination.index === 30) {
        posterMrNancyBG.classList.add('posterBGAni')
        posterMrNancy.classList.add('posterCharAni')
      } else {
        posterMrNancyBG.classList.remove('posterBGAni')
        posterMrNancy.classList.remove('posterCharAni')
      }
      if (destination.index === 31 || destination.index === 30 || destination.index === 32) {
        document.getElementById('charInformation-MrNancy').classList.add('loadImage')
      }
      if (destination.index === 32 || destination.index === 31 || destination.index === 33) {
        document.getElementById('charPortrait-MrNancy').classList.add('loadImage')
      }
      if (destination.index === 33 || destination.index === 32 || destination.index === 34) {
        document.getElementById('MrNancy-Slide0').classList.add('loadImage')
        document.getElementById('MrNancy-Slide1').classList.add('loadImage')
        document.getElementById('MrNancy-Slide2').classList.add('loadImage')
      }
      var posterBilquisBG = document.querySelector('#posterBilquisBG')
      var posterBilquis = document.querySelector('#posterBilquis')
      if (destination.index === 2 || destination.index === 34 || destination.index === 33 || destination.index === 35) {
        posterBilquisBG.classList.add('loadImage')
        posterBilquis.classList.add('loadImage')
      }
      if (destination.index === 34) {
        posterBilquisBG.classList.add('posterBGAni')
        posterBilquis.classList.add('posterCharAni')
      } else {
        posterBilquisBG.classList.remove('posterBGAni')
        posterBilquis.classList.remove('posterCharAni')
      }
      if (destination.index === 35 || destination.index === 34 || destination.index === 36) {
        document.getElementById('charInformation-Bilquis').classList.add('loadImage')
      }
      if (destination.index === 36 || destination.index === 35 || destination.index === 37) {
        document.getElementById('charPortrait-Bilquis').classList.add('loadImage')
      }
      if (destination.index === 37 || destination.index === 36 || destination.index === 38) {
        document.getElementById('Bilquis-Slide0').classList.add('loadImage')
        document.getElementById('Bilquis-Slide1').classList.add('loadImage')
        document.getElementById('Bilquis-Slide2').classList.add('loadImage')
      }
      var posterTechBoyBG = document.querySelector('#posterTechBoyBG')
      var posterTechBoy = document.querySelector('#posterTechBoy')
      if (destination.index === 2 || destination.index === 38 || destination.index === 37 || destination.index === 39) {
        posterTechBoyBG.classList.add('loadImage')
        posterTechBoy.classList.add('loadImage')
      }
      if (destination.index === 38) {
        posterTechBoyBG.classList.add('posterBGAni')
        posterTechBoy.classList.add('posterCharAni')
      } else {
        posterTechBoyBG.classList.remove('posterBGAni')
        posterTechBoy.classList.remove('posterCharAni')
      }
      if (destination.index === 39 || destination.index === 38 || destination.index === 40) {
        document.getElementById('charInformation-TechBoy').classList.add('loadImage')
      }
      if (destination.index === 40 || destination.index === 39 || destination.index === 41) {
        document.getElementById('charPortrait-TechBoy').classList.add('loadImage')
      }
      if (destination.index === 41 || destination.index === 40 || destination.index === 42) {
        document.getElementById('TechBoy-Slide0').classList.add('loadImage')
        document.getElementById('TechBoy-Slide1').classList.add('loadImage')
        document.getElementById('TechBoy-Slide2').classList.add('loadImage')
      }
      var posterMrWorldBG = document.querySelector('#posterMrWorldBG')
      var posterMrWorld = document.querySelector('#posterMrWorld')
      if (destination.index === 2 || destination.index === 42 || destination.index === 41 || destination.index === 43) {
        posterMrWorldBG.classList.add('loadImage')
        posterMrWorld.classList.add('loadImage')
      }
      if (destination.index === 42) {
        posterMrWorldBG.classList.add('posterBGAni')
        posterMrWorld.classList.add('posterCharAni')
      } else {
        posterMrWorldBG.classList.remove('posterBGAni')
        posterMrWorld.classList.remove('posterCharAni')
      }
      if (destination.index === 43 || destination.index === 42 || destination.index === 44) {
        document.getElementById('charInformation-MrWorld').classList.add('loadImage')
      }
      if (destination.index === 44 || destination.index === 43 || destination.index === 45) {
        document.getElementById('charPortrait-MrWorld').classList.add('loadImage')
      }
      if (destination.index === 45 || destination.index === 44 || destination.index === 46) {
        document.getElementById('MrWorld-Slide0').classList.add('loadImage')
        document.getElementById('MrWorld-Slide1').classList.add('loadImage')
        document.getElementById('MrWorld-Slide2').classList.add('loadImage')
      }
    }
  },
  mounted: function () {
    var theBGShadow = document.querySelector('#charBG-ShadowMoon')
    var theBGWedensday = document.querySelector('#charBG-MrWedensday')
    var theBGLauraMoon = document.querySelector('#charBG-LauraMoon')
    var theBGMadSweeney = document.querySelector('#charBG-MadSweeney')
    var theBGMrIbis = document.querySelector('#charBG-MrIbis')
    var theBGSalim = document.querySelector('#charBG-Salim')
    var theBGTheJinn = document.querySelector('#charBG-TheJinn')
    var theBGMrNancy = document.querySelector('#charBG-MrNancy')
    var theBGBilquis = document.querySelector('#charBG-Bilquis')
    var theBGTechBoy = document.querySelector('#charBG-TechBoy')
    var theBGMrWorld = document.querySelector('#charBG-MrWorld')
    var theCircle = document.querySelector('#charCircle')
    var shadowMoon = document.querySelector('#iconShadowMoon')
    var mrWedensday = document.querySelector('#iconMrWedensday')
    var lauraMoon = document.querySelector('#iconLauraMoon')
    var madSweeney = document.querySelector('#iconMadSweeney')
    var mrIbis = document.querySelector('#iconMrIbis')
    var salim = document.querySelector('#iconSalim')
    var theJinn = document.querySelector('#iconTheJinn')
    var mrNancy = document.querySelector('#iconMrNancy')
    var bilquis = document.querySelector('#iconBilquis')
    var techBoy = document.querySelector('#iconTechBoy')
    var mrWorld = document.querySelector('#iconMrWorld')

    // Shadow Moon
    shadowMoon.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-ShadowMoon')
      // Background
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGShadow.classList.add('charBG-ShadowMoon')
    })

    // Mr Wedensday
    mrWedensday.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-MrWedensday')
      // background
      theBGShadow.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGWedensday.classList.add('charBG-MrWedensday')
    })

    // Laura Moon
    lauraMoon.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-LauraMoon')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGLauraMoon.classList.add('charBG-LauraMoon')
    })

    // Mad Sweeney
    madSweeney.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-MadSweeney')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGMadSweeney.classList.add('charBG-MadSweeney')
    })

    // Mr Ibis
    mrIbis.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-MrIbis')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGMrIbis.classList.add('charBG-MrIbis')
    })

    // Salim
    salim.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-Salim')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGSalim.classList.add('charBG-Salim')
    })

    // The Jinn
    theJinn.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-TheJinn')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGTheJinn.classList.add('charBG-TheJinn')
    })

    // Mr Nancy
    mrNancy.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-MrNancy')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGMrNancy.classList.add('charBG-MrNancy')
    })

    // Bilquis
    bilquis.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-Bilquis')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGBilquis.classList.add('charBG-Bilquis')
    })

    // Tech Boy
    techBoy.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-TechBoy')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGMrWorld.removeAttribute('class')
      theBGTechBoy.classList.add('charBG-TechBoy')
    })

    // Mr. World
    mrWorld.addEventListener('mouseover', function () {
      theCircle.removeAttribute('class')
      theCircle.classList.add('isActive-MrWorld')
      // background
      theBGShadow.removeAttribute('class')
      theBGWedensday.removeAttribute('class')
      theBGLauraMoon.removeAttribute('class')
      theBGMadSweeney.removeAttribute('class')
      theBGMrIbis.removeAttribute('class')
      theBGSalim.removeAttribute('class')
      theBGTheJinn.removeAttribute('class')
      theBGMrNancy.removeAttribute('class')
      theBGBilquis.removeAttribute('class')
      theBGTechBoy.removeAttribute('class')
      theBGMrWorld.classList.add('charBG-MrWorld')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Characters.scss";
  @import "../styles/CharactersItems.scss";
  @import "../styles/CharactersItemsShadowMoon.scss";
  @import "../styles/CharactersItemsMrWedensday.scss";
  @import "../styles/CharactersItemsLauraMoon.scss";
  @import "../styles/CharactersItemsMadSweeney.scss";
  @import "../styles/CharactersItemsMrIbis.scss";
  @import "../styles/CharactersItemsSalim.scss";
  @import "../styles/CharactersItemsTheJinn.scss";
  @import "../styles/CharactersItemsMrNancy.scss";
  @import "../styles/CharactersItemsBilquis.scss";
  @import "../styles/CharactersItemsTechBoy.scss";
  @import "../styles/CharactersItemsMrWorld.scss";
</style>



// WEBPACK FOOTER //
// src/components/Characters.vue